import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import Logo from '../Components/Logo';

import Loading from '../Components/Loading';

import styles from '../styles/Auth.module.css';
import stylesLogo from '../styles/Logo.module.css';
import modalStatus from '../styles/DynamicModal.module.css';

const Registration = () => {
  const [email, setEmail] = React.useState('');
  const [emailSent, setEmailSent] = React.useState(false);
  const [verificationCode, setVerificationCode] = React.useState('');
  const [isVerified, setIsVerified] = React.useState(false);
  const [lastname, setLastname] = React.useState('');
  const [firstname, setFirstname] = React.useState('');
  const [surname, setSurname] = React.useState('');
  const [branch, setBranch] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [passwordConfirm, setPasswordConfirm] = React.useState('');
  const [status, setStatus] = React.useState('');
  const [error, setError] = React.useState('');

  const [buttonGo, setButtonGo] = React.useState('Отправить код');
  const [isDisabled, setIsDisabled] = React.useState(false);

  const [dbStatus, setDbStatus] = React.useState('checking');
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const fetchData = async () => {
      try {
          const response = await axios.get('/api/health');
          if (response.status === 200) {
              setDbStatus('connected');
          }
      } catch (err) {
          setDbStatus('Отсутствует подключение к серверу');
      } finally {
          setLoading(false);
      }
  };

  fetchData();
  }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setButtonGo('Загрузка...');
    setIsDisabled(true);
    try {
      await axios.post('/api/send-verification-code', { email });
      setEmailSent(true);
      setButtonGo('Подтвердить код');
      setIsDisabled(false);
    } catch (err) {
      setError('Ошибка системы. Код не отправлен');
      setButtonGo('Отправить код');
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setButtonGo('Загрузка...');
    setIsDisabled(true);
    try {
      const response = await axios.post('/api/verify-code', { email, verificationCode });
      if (response.data.success) {
        setIsVerified(true);
        setButtonGo('Зарегистрироваться');
        setIsDisabled(false);
      } else {
        setStatus('Неверный код');
        setButtonGo('Подтвердить код');
      }
    } catch (err) {
      setStatus('Ошибка системы. Не удалось проверить код');
      setButtonGo('Подтвердить код');
    }
  };

  const handleRegistrationSubmit = async (e) => {
    e.preventDefault();
    setButtonGo('Загрузка...');
    setIsDisabled(true);
    try {
      const response = await axios.post('/api/registration', {
        email,
        lastname,
        firstname,
        surname,
        branch,
        password,
        passwordConfirm,
      });
      setIsDisabled(false);
      if (response.data.token) {
        setStatus(response.data.message || 'Ошибка системы.');
        setButtonGo('Готово');
        localStorage.setItem('token', response.data.token);
        window.location.href = '/';
      } else {
        setStatus(response.data.message);
        setButtonGo('Готово');
      }
    } catch (err) {
      setStatus('Регистрация учетной записи не завершена: ' + err.message || 'Ошибка сети.');
      setButtonGo('Зарегистрироваться');
    }
  };

  return (
    <>
    {loading ? (
      <Loading />
    ) : dbStatus === 'connected' ? (
      <div className={styles.indexMain}>
        <div className={styles.indexForm}>
          <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>
          {!emailSent ? (
            <form className={styles.liningForm} onSubmit={handleEmailSubmit}>
              <div className={styles.liningHeader}>
                <h1>Зарегистрируйте профиль в удобном журнале «Поток»</h1>
                <Link to='/' style={{ display: 'flex' }}>
                  <img src='/img/icons/close-x.svg' className={styles.closeButton} />
                </Link>
              </div>
              <div className={styles.liningBody}>
                <a>Введите адрес электронной почты</a>
                <input
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder='Введите e-mail'
                  minLength='3'
                  maxLength='100'
                  required
                />
                <p className={styles.infoBlock}>Необходимо ввести рабочий e-mail, поскольку Вы будете получать важные уведомления.</p>
                {error && <a className={`${modalStatus.statusPanel} ${styles.red}`}><img src='/img/icons/error-icon.svg' alt='Ошибка' />{error}</a>}
                {status && <a className={modalStatus.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                <button className='button maxWidth' type='submit' disabled={isDisabled}>{buttonGo}</button>
                <a className={styles.or}>У вас уже есть учетная запись?</a>
                <Link to='/auth/login' className={styles.goToAnAuth}>Быстрый вход</Link>
                <Link className={styles.labelForPolicy} to='/privacy-policy'>Продолжая, вы подтверждаете, что понимаете и соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</Link>
              </div>
            </form>
          ) : !isVerified ? (
            <form className={styles.liningForm} onSubmit={handleCodeSubmit}>
              <div className={styles.liningHeader}>
                <h1>Введите код подтверждения</h1>
                <Link to='/' style={{ display: 'flex' }}>
                  <img src='/img/icons/close-x.svg' className={styles.closeButton} />
                </Link>
              </div>
              <div className={styles.liningBody}>
                <a>На Вашу электронную почту отправлено письмо с 6-значным кодом</a>
                <input
                  type='text'
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder='Введите код'
                  minLength='6'
                  maxLength='6'
                  required
                />
                {error && <a className={`${modalStatus.statusPanel} ${styles.red}`}><img src='/img/icons/error-icon.svg' alt='Ошибка' />{error}</a>}
                {status && <a className={modalStatus.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                <button className='button maxWidth' type='submit' disabled={isDisabled}>{buttonGo}</button>
                <Link className={styles.labelForPolicy} to='/privacy-policy'>Продолжая, вы подтверждаете, что понимаете и соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</Link>
              </div>
            </form>
          ) : (
            <form className={styles.liningForm} onSubmit={handleRegistrationSubmit}>
              <div className={styles.liningHeader}>
                <h1>Зарегистрируйте профиль в удобном журнале «Поток»</h1>
                <Link to='/' style={{ display: 'flex' }}>
                  <img src='/img/icons/close-x.svg' className={styles.closeButton} />
                </Link>
              </div>
              <div className={styles.liningBody}>
                <a>Введите фамилию</a>
                <input
                  type='text'
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  placeholder='Введите фамилию'
                  minLength='3'
                  maxLength='100'
                  required
                />
                <a>Введите имя</a>
                <input
                  type='text'
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  placeholder='Введите имя'
                  minLength='4'
                  maxLength='180'
                  required
                />
                <a>Введите отчество</a>
                <input
                  type='text'
                  value={surname}
                  onChange={(e) => setSurname(e.target.value)}
                  placeholder='Введите отчество'
                  minLength='4'
                  maxLength='180'
                  required
                />
                <a>Введите основной регион деятельности</a>
                <input
                  type='text'
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                  placeholder='Например, Нижегородская область'
                  minLength='4'
                  maxLength='180'
                  required
                />
                <a>Введите пароль</a>
                <input
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder='Введите пароль'
                  minLength='4'
                  maxLength='180'
                  required
                />
                <a>Повторите пароль</a>
                <input
                  type='password'
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  placeholder='Введите пароль повторно'
                  minLength='4'
                  maxLength='180'
                  required
                />
                {error && <a className={`${modalStatus.statusPanel} ${styles.red}`}><img src='/img/icons/error-icon.svg' alt='Ошибка' />{error}</a>}
                {status && <a className={modalStatus.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                <button className='button maxWidth' type='submit' disabled={isDisabled}>{buttonGo}</button>
                <Link className={styles.labelForPolicy} to='/privacy-policy'>Продолжая, вы подтверждаете, что понимаете и соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    ) : (
        <span style={{display: 'flex', flexDirection: 'column', padding: '10px', boxSizing: 'border-box'}}>
            <a>Система «Поток» в данный момент недоступна.</a>
            <a>Статус: {dbStatus}</a>
        </span>
    )}
    </>
  );
};

export default Registration;
